<script setup lang="ts">
import { shallowRef, watchEffect } from 'vue';
import { ConfirmationSnackbarOptions } from '@/modules/marketplace/types/marketplace';

const emit = defineEmits<{
  (event: 'close'): void;
  (event: 'view-order', orderRef: string | null): void;
}>();

defineProps<{ options: ConfirmationSnackbarOptions }>();

const show = shallowRef(true);
watchEffect(() => {
  if (!show.value) {
    emit('close');
  }
});
</script>

<template>
  <VSnackbar
    v-model="show"
    :color="options.error ? 'error' : 'primary'"
    data-test="confirmation-snackbar"
  >
    {{ options.message }}
    <template #action>
      <VBtn
        v-if="options.showViewButton"
        data-test="view-order-button"
        small
        text
        @click="
          emit('view-order', options.orderRef);
          show = false;
        "
      >
        View Order
      </VBtn>
      <VBtn color="white" icon small text @click="show = false">
        <VIcon size="16">mdi-close</VIcon>
      </VBtn>
    </template>
  </VSnackbar>
</template>

<style lang="scss" scoped></style>
